import { ReactElement } from 'react';
import { ConditionalWrapper } from 'components/ConditionalWrapper';
import './index.less';

export const ImageOverlay = ({
  condition,
  children
}: {
  condition?: boolean;
  children: ReactElement;
}): ReactElement => {
  return (
    <>
      {condition && <div className="imageOverlay" />}
      <ConditionalWrapper
        condition={!!condition}
        wrapper={children => <div className="overlayContent">{children}</div>}
      >
        {children}
      </ConditionalWrapper>
    </>
  );
};
